$(function(){
        getCartCount();
let gift_id = '52222292689237'
   console.log('gift id',gift_id);
   let result;
   function getCartCount() {
     setTimeout(function(){
    $.getJSON('/cart.js', function(cart){ 
      console.log(cart);
     result = cart.total_price;
      console.log(result);
     },1000)
})
}
  $(document).on('click','.cart-drawer__overlay',function(){
    $('.u_cart_drawer').removeClass('active')
    $('body').removeClass('overflow-hidden')
  })
let thresold = 100000;
document.addEventListener('click', function (e) {
  const btn = e.target.closest('.upcart-internal-component-product-tile__quantity-plus');

  if (!btn) return;

  console.log('UpCart plus clicked ✔');
});
  $(document).on('click','.upcart-internal-component-product-tile__quantity-plus',function(){
    console.log('click')
    setTimeout(function(){
               $.getJSON('/cart.js', function(cart){ 
      console.log(cart);
       var cart_price = cart.total_price;
      console.log(result);
      if (cart_price >= thresold){
     $.ajax({
        type:'POST',
        url:'/cart/add.js',
        data : {
        "id": gift_id  ,
        "quantity": 1,        
      },
 dataType: 'json',
        success: function(result){
        console.log('success');   
        document.dispatchEvent(new CustomEvent('upcart:request'));
  
  // 3. (Optional) Open the Upcart drawer if it isn't already visible
  document.dispatchEvent(new CustomEvent('upcart:open'));
      },
             error: function(err) {
        console.log('error',err); 
      },
         complete: function() {
                      console.log('complete');           
      }
    })        
}
               })
            })

  })
})